import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch categories for a specific branch of a restaurant
 * @param {number} restaurantId - The restaurant ID
 * @param {number} branchId - The branch ID
 * @param {string} language - The language parameter (default: 'en')
 * @returns {Promise<Object>} - Response data from the API
 */
export const getBranchCategories = async (
  restaurantId,
  branchId,
  language = "en"
) => {
  try {
    const response = await apiClient.get(
      `${API_ENDPOINTS.RESTAURANT}/${restaurantId}/branch/${branchId}/categories`,
      {
        params: { language },
      }
    );
    return response.data.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
